/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var UiCursorAIcon16Light = forwardRef('UiCursorAIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3.005 3.528c.001-1.236 1.413-1.94 2.401-1.197l7.945 5.973c1.152.866.539 2.7-.903 2.699l-3.97-.005a.5.5 0 0 0-.4.2L5.693 14.37c-.867 1.152-2.701.538-2.7-.903l.012-9.94Zm1.8-.398a.5.5 0 0 0-.8.4l-.011 9.939a.5.5 0 0 0 .9.301l2.385-3.173a1.5 1.5 0 0 1 1.2-.599l3.97.005a.5.5 0 0 0 .301-.9L4.805 3.13Z" })));
});
